// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1TKUu","header":"_13Xgn","divider":"_23h8U"};